import"./jbBfcmTheme.css.ts.vanilla.css";var e="jbBfcmTheme_jbBfcmTheme__qllww50";export{e as jbBfcmTheme};
//# sourceMappingURL=jbBfcmTheme.css.vanilla.js.map
